export default {"src":"/_next/static/media/compliance.026e68aa.svg","height":20,"width":21};